/* Use case: sounds (sections/ls-use-sounds.liquid, layout "rows"): rows fade in one after another when the list
   scrolls into view. Without IntersectionObserver or with reduced motion the rows are simply shown. */
(() => {
  const lists = document.querySelectorAll('[data-lus-rows]:not([data-lus-ready])');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  lists.forEach((list) => {
    list.dataset.lusReady = '1';
    if (reduced || !('IntersectionObserver' in window)) return;
    const rect = list.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.9) return;
    list.classList.add('is-pending');
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      list.classList.remove('is-pending');
      list.classList.add('is-in');
    }, { rootMargin: '0px 0px -12% 0px' });
    io.observe(list);
  });
})();
